import { Route, Routes } from "react-router-dom";
// import OperationsHome from "../../pages/Admin/Operations/OperationsHome";
import BidSectorTable from "../../pages/Admin/Operations/BidSector/BidSectorTable";
import TierStatus from "../../pages/Admin/Operations/Tier/TierStatus";
import {
  CompaintTable,
  CropManagementForm,
  EarnCropsTable,
  // Marcom,
  HolidaysTable,
  InterestForm,
  InterestTable,
  LoyalityForm,
  LoyalityTable,
  ManagementRequest,
  ManagementRequestForm,
  ManagementService,
  OperationsManagementCards,
  PaymentHistoryTable,
  PaymentTable,
  SectorTable,
  ServiceChargesForm,
  ServiceChargesTable,
  SetSector,
  Status,
  TierForm,
  TierTable,
  UpdatePopup,
} from "../../pages/Admin/index";

const OperationsRoute = () => {
  return (
    <Routes>
      <Route path="/loyality-list" element={<LoyalityTable />} />
      <Route path="/loyality-form" element={<LoyalityForm />} />
      <Route path="/service-charges-list" element={<ServiceChargesTable />} />
      <Route path="/service-charges-form" element={<ServiceChargesForm />} />
      <Route path="/interest-form" element={<InterestForm />} />
      <Route path="/home" element={<OperationsManagementCards />} />
      <Route path="/management-services-list" element={<ManagementService />} />
      <Route path="/management-request-list" element={<ManagementRequest />} />
      <Route path="/request-form" element={<ManagementRequestForm />} />
      <Route path="/operations-compaint-list" element={<CompaintTable />} />
      <Route path="/earn-crops-list" element={<EarnCropsTable />} />
      <Route path="/holidays-list" element={<HolidaysTable />} />
      <Route path="/sector-list" element={<SectorTable />} />
      <Route path="/interest-list" element={<InterestTable />} />
      <Route path="/payment-list" element={<PaymentTable />} />
      <Route path="/payment-history-list/:id" element={<PaymentHistoryTable />} />
      <Route path="/crop-management" element={<CropManagementForm />} />
      <Route path="/tier-list" element={<TierTable />} />
      <Route path="/tier-form" element={<TierForm />} />
      <Route path="/status" element={<Status />} />
      <Route path="/tire-status" element={<TierStatus />} />
      <Route path="/bidsector-list" element={<BidSectorTable />} />
      <Route path="/update-popup-form" element={<UpdatePopup />} />
      <Route path="/set-sector" element={<SetSector />} />
    </Routes>
  );
};

export default OperationsRoute;
